import React, { ReactElement, useCallback, useEffect, useState } from 'react';
import 'antd/dist/antd.css';
import {
  Switch,
  Link,
  useLocation,
  Redirect,
  useHistory,
} from 'react-router-dom';
import styles from './index.module.scss';
import { Layout, Menu } from 'antd';
import {
  FileOutlined,
  GiftOutlined,
  AccountBookOutlined,
  UserOutlined,
  LogoutOutlined,
  UploadOutlined,
} from '@ant-design/icons';

const { Header, Content, Footer, Sider } = Layout;
import UserAccountPage from '../useraccount';
import LogPage from '../log';
import UserAdminPage from '../useradmin';
import GiftCardPage from '../giftcard';
import UserDetailPage from '../userdetail';
import ChildDetailPage from '../childdetail';
import GiftDetailPage from '../giftdetail';
import CreateAdminPage from '../createupdateadmin';
import UpdateSuperAdminPW from '../updatesuperadminpw';
import { useDispatch } from 'react-redux';
import { logoutWealthie } from '../../store/reducers/authSlice';
import PrivateRoute from '../../components/AuthenticationRoute/PrivateRoute';
import Button from '../../components/Button';
import { Auth } from 'aws-amplify';

function RootPrivate(): ReactElement {
  const [collapsed, setCollapsed] = useState(false);
  const [isSuperAdmin, setSuperAdmin] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const onCollapse = (collapsed: boolean) => {
    setCollapsed(collapsed);
  };

  const onLogout = useCallback(() => {
    dispatch(logoutWealthie());
  }, [dispatch]);

  const onUpdatePW = useCallback(() => {
    history.push('/user-admin/super-admin-pw');
  }, [history]);

  useEffect(() => {
    Auth.currentAuthenticatedUser()
      .then(({ attributes: { ['custom:role']: role } }) => {
        setSuperAdmin(role === 'super-admin');
      })
      .catch(() => setSuperAdmin(false));
  }, []);

  return (
    <Layout>
      <Sider
        style={{
          overflow: 'auto',
          height: '100vh',
          position: 'sticky',
          top: 0,
          left: 0,
        }}
        collapsible
        collapsed={collapsed}
        onCollapse={onCollapse}
      >
        <img src="/cropped-wealthie-fav-300x300.png" className={styles.logo} />
        <Menu
          theme="dark"
          defaultSelectedKeys={[location.pathname]}
          mode="inline"
        >
          <Menu.Item key={`/users`} icon={<AccountBookOutlined />}>
            <Link to={`/users`}>User Accounts</Link>
          </Menu.Item>
          <Menu.Item key={`/gift-card`} icon={<GiftOutlined />}>
            <Link to={`/gift-card`}>Giftcards</Link>
          </Menu.Item>
          <Menu.Item key={`/log`} icon={<FileOutlined />}>
            <Link to={`/log`}>Log</Link>
          </Menu.Item>
          <Menu.Item key={`/user-admin`} icon={<UserOutlined />}>
            <Link to={`/user-admin`}>Admin Users</Link>
          </Menu.Item>
        </Menu>
      </Sider>
      <Layout className={styles.site_layout}>
        <Header
          className={`${styles.site_layout_background} ${styles.logout_section}`}
          style={{ padding: 0 }}
        >
          <Button
            onClick={onLogout}
            className={styles.logout_button}
            icon={<LogoutOutlined />}
          >
            Logout
          </Button>
          {isSuperAdmin && (
            <Button
              onClick={onUpdatePW}
              className={styles.logout_button}
              icon={<UploadOutlined />}
            >
              Update Password
            </Button>
          )}
        </Header>
        <Content style={{ margin: '0 16px' }}>
          <Switch>
            <PrivateRoute exact path={`/users`} component={UserAccountPage} />
            <PrivateRoute exact path={`/gift-card`} component={GiftCardPage} />
            <PrivateRoute exact path={`/log`} component={LogPage} />
            <PrivateRoute
              exact
              path={`/user-admin`}
              component={UserAdminPage}
            />
            <PrivateRoute
              exact
              path={`/users/:id`}
              component={UserDetailPage}
            />
            <PrivateRoute
              exact
              path={`/child/:parentId/:id`}
              component={ChildDetailPage}
            />
            <PrivateRoute
              component={GiftDetailPage}
              exact
              path={`/gift-card/:giftId`}
            />
            <PrivateRoute
              component={CreateAdminPage}
              exact
              path={`/user-admin/create`}
            />
            <PrivateRoute
              component={CreateAdminPage}
              exact
              path={`/user-admin/edit/:adminId`}
            />
            <PrivateRoute
              component={UpdateSuperAdminPW}
              exact
              path={`/user-admin/super-admin-pw`}
            />
            <Redirect to="/users" />
          </Switch>
        </Content>
        <Footer style={{ textAlign: 'center' }}>Wealthie Admin ©2021</Footer>
      </Layout>
    </Layout>
  );
}

export default RootPrivate;
